export function enabledFeatureFlag(value: string | undefined, defaultValue = false) {
    if (value === undefined || value.trim() === "") return defaultValue;
    return ["1", "true", "yes", "on"].includes(value.trim().toLowerCase());
}

export const FEATURES = Object.freeze({
    mockInterviews: enabledFeatureFlag(process.env.REACT_APP_ENABLE_MOCK_INTERVIEWS),
});
